import SpainCnoOccupation from 'modules/contracts/store/models/SpainCnoOccupation'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

export interface ICnoOccupation {
  id: number
  legal_entity_id: number
  name: string
  default: boolean
  archived: boolean
}

class CnoOccupations extends PayrollLegalEntityResource<SpainCnoOccupation> {
  get cacheKey(): string {
    return 'cnoOccupations'
  }

  model() {
    return SpainCnoOccupation
  }
}

export { CnoOccupations }
